// extracted by mini-css-extract-plugin
module.exports = {"container":"Progress_container__13eKT","progress":"Progress_progress__vD6i-","completed":"Progress_completed__2na46"};